import commaNumber from 'comma-number';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {fetchPaymentCancelRequestsForCurrentUser} from '../../../../actions/paymentCancelRequest.action';
import {fetchRefundRequestsForCurrentUser} from '../../../../actions/refundRequest.actions';
import {fetchProductEntitlementsWithPurchasesForCurrentUser} from '../../../../actions/usageStatus.actions';
import {PAYMENT_CANCEL_REQUEST_STATUSES} from '../../../../constants/paymentCancelRequest.constants';
import {REFUND_REQUEST_STATUSES} from '../../../../constants/refundRequest.constants';
import {
  getRefundAmount,
  isRefundableEntitlement,
  isRefundableWithNoRefundCharge,
  refundFees,
} from '../../../../util/refundAndCancelUtil';
import {convertTimeCreditToPcBangPoint} from '../../../../util/timeUtils';
import {PageSubTitle, Button, ButtonGroup, Table} from '../../../Common/PageComponents';
import moment from 'moment';
import './refund.scss';

const stateToProps = state => {
  return {
    pcbId: state.user.pcbId,
    refundRequests: state.refundRequest.refundRequests,
    paymentCancelRequests: state.paymentCancelRequest.paymentCancelRequests,
    productEntitlements: state.usageStatus.productEntitlements,
    purchases: state.purchase.purchases,
  };
};

class RefundOverview extends Component {
  componentDidMount() {
    this.props.dispatch(fetchRefundRequestsForCurrentUser());
    this.props.dispatch(fetchPaymentCancelRequestsForCurrentUser());
    this.props.dispatch(fetchProductEntitlementsWithPurchasesForCurrentUser());
  }

  _renderRefundRequests(refundRequests) {
    return refundRequests.map(refundRequest => (
      <tr key={refundRequest.productEntitlementId}>
        <td>{refundRequest.archivedProductEntitlement.name}</td>
        <td>{commaNumber(refundRequest.purchase.product.price)} 원</td>
        <td>{convertTimeCreditToPcBangPoint(refundRequest.purchase.product.timeCredit)}</td>
        <td>{convertTimeCreditToPcBangPoint(refundRequest.archivedProductEntitlement.remainingTimeCredit)}</td>
        <td>
          {isRefundableWithNoRefundCharge(
            refundRequest.archivedProductEntitlement,
            refundRequest.purchase,
            moment(refundRequest.created)
          )
            ? '0'
            : commaNumber(
                refundFees(
                  refundRequest.purchase.product.price,
                  refundRequest.purchase.product.timeCredit,
                  refundRequest.archivedProductEntitlement.remainingTimeCredit
                )
              )}{' '}
          원
        </td>
        <td>{commaNumber(refundRequest.refundableAmountAfterRefundCharge)} 원</td>
        <td>{REFUND_REQUEST_STATUSES[refundRequest.status]}</td>
      </tr>
    ));
  }

  _renderPaymentCancelRequests(paymentCancelRequests) {
    return paymentCancelRequests.map(cancelRequest => (
      <tr key={cancelRequest.productEntitlementId}>
        <td>{cancelRequest.archivedProductEntitlement.name}</td>
        <td>{commaNumber(cancelRequest.purchase.product.price)} 원</td>
        <td>{convertTimeCreditToPcBangPoint(cancelRequest.purchase.product.timeCredit)}</td>
        <td>{convertTimeCreditToPcBangPoint(cancelRequest.archivedProductEntitlement.remainingTimeCredit)}</td>
        <td>
          {isRefundableWithNoRefundCharge(
            cancelRequest.archivedProductEntitlement,
            cancelRequest.purchase,
            moment(cancelRequest.created)
          )
            ? '0'
            : commaNumber(
                refundFees(
                  cancelRequest.purchase.product.price,
                  cancelRequest.purchase.product.timeCredit,
                  cancelRequest.archivedProductEntitlement.remainingTimeCredit
                )
              )}{' '}
          원
        </td>
        <td>{commaNumber(cancelRequest.paidPrice)} 원</td>
        <td>{PAYMENT_CANCEL_REQUEST_STATUSES[cancelRequest.status]}</td>
      </tr>
    ));
  }

  _renderProductEntitlements(entitlements, purchases) {
    return entitlements.map(entitlement => {
      if (isRefundableEntitlement(entitlement)) {
        let purchase = purchases[entitlement.entitlementId];
        return (
          purchase && (
            <tr key={entitlement.entitlementId}>
              <td>{entitlement.name}</td>
              <td>{commaNumber(purchase.product.price)} 원</td>
              <td>{convertTimeCreditToPcBangPoint(entitlement.totalTimeCredit)}</td>
              <td>{convertTimeCreditToPcBangPoint(entitlement.remainingTimeCredit)}</td>
              <td>
                {isRefundableWithNoRefundCharge(entitlement, purchase)
                  ? 0
                  : commaNumber(
                      refundFees(purchase.product.price, entitlement.totalTimeCredit, entitlement.remainingTimeCredit)
                    )}{' '}
                원
              </td>
              <td>{commaNumber(purchase ? getRefundAmount(entitlement, purchase) : '')} 원</td>
              <td>{'-'}</td>
            </tr>
          )
        );
      }
    });
  }

  _renderEmptyRowIfEmpty(productEntitlements, refundRequests, paymentCancelRequests) {
    productEntitlements = productEntitlements.filter(entitlements => isRefundableEntitlement(entitlements));
    if (!productEntitlements.length && !refundRequests.length && !paymentCancelRequests.length) {
      return (
        <tr>
          <td colSpan="7">사용 중인 상품이 없습니다.</td>
        </tr>
      );
    }
  }

  render() {
    let {refundRequests, paymentCancelRequests, productEntitlements, purchases} = this.props;
    return (
      <div>
        <PageSubTitle title="환불 신청 안내" />
        <p>환불은 당사의 약관에 근거하여 결제 이후에도 구매하신 상품을 취소, 환불을 요구하실 수 있습니다.</p>
        <Table>
          <colgroup>
            <col width={150} />
            <col width={149} />
            <col width={174} />
            <col width={215} />
            <col width={215} />
            <col width={215} />
            <col width={215} />
          </colgroup>
          <thead>
            <th>상품명</th>
            <th>구매 금액</th>
            <th>충전된 포인트</th>
            <th>잔여 포인트</th>
            <th>환불 수수료</th>
            <th>총 환불금액</th>
            <th>진행상황</th>
          </thead>
          <tbody>
            {this._renderProductEntitlements(productEntitlements, purchases)}
            {this._renderRefundRequests(refundRequests)}
            {this._renderPaymentCancelRequests(paymentCancelRequests)}
            {this._renderEmptyRowIfEmpty(productEntitlements, refundRequests, paymentCancelRequests)}
          </tbody>
        </Table>
        <div className="online-or-offline">
          <div className="box">
            <p className="box__head">온라인 환불신청</p>
            <Link to="/my-pc-bang/usage-status/refund/application">
              <Button className="bottom" size="small" data-qa="refundOverviewButton">
                온라인 결제취소/환불신청 바로가기
              </Button>
            </Link>
          </div>
          <div className="box">
            <p className="box__head">오프라인 환불 신청</p>
            <p className="offline-guide-text">
              <br />
              환불신청서를 다운로드 받으신 후 작성하여 FAX로 발송해 <br />
              주시거나 스캔 후 [고객센터 &gt; 1:1문의]를 통해 파일 첨부하여 발송해 주시면 됩니다.(대표자 서명 혹은 날인
              필수)
            </p>
            <ButtonGroup className="bottom">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://lolstatic-a.akamaihd.net/riot-kr/docs/pcbang/RefundRequest_210708.pdf"
              >
                <Button size="small" theme={'black'}>
                  환불신청서 다운로드
                </Button>
              </a>
              <Link to="/customer/inquiries">
                <Button size="small">1:1 문의바로가기</Button>
              </Link>
            </ButtonGroup>
          </div>
        </div>
        <PageSubTitle title="환불 금액은 어떻게 계산되나요?" />
        <p>
          환불 진행 시에는 남아있는 포인트의 10%가 환불 수수료로 부과되어 계산됩니다. <br />
          환불금액 = A(구매 금액/충전된 포인트*잔여 포인트) - B[환불수수료(A의 10%)] <br />
          예) 642,000원 상품 (699,000 포인트) 구매 후 300,000 포인트 사용 후 잔여 포인트에 대한 환불 요청 시<br />=
          A([구매금액 642,000원]/[구매시 부여 699,000포인트]*[잔여 399,000 포인트]) - B(A*10%) = 329,817 원
        </p>
      </div>
    );
  }
}

export default connect(stateToProps)(RefundOverview);
